<template>
  <div class="bg">
    <div class="main">
      <div class="selectdivAll">
        <div class="majordiv clearfix" :class="{ autoHeight: onOff }">
          <div
            class="majorText  secondstyle"
            :class="{ autoHeightMajor: onOff }"
          >
            出版社：
          </div>
          <div class="border searchul clearfix" :class="{ autoHeightUL: onOff }">
            <ul
              class="majorul clearfix left"
              :class="{ autoHeightULseco: onOff }"
            >
              <li
                v-for="(item, index) in pressData"
                class="left"
                :key="index"
                @click="selectPress(index,item.id)"
                :class="{ activeMajor: item.id == currentPress }"
              >
                {{ item.name }}
              </li>
            </ul>
            <div class="right onOfftext" @click="openOrShut">
              {{ onOff ? '收起' : '展开' }}
              <img
                v-if="!onOff"
                class="arrowimg"
                src="../../assets/img/down.png"
                alt=""
              />
              <img
                v-else
                class="arrowimg"
                src="../../assets/img/up.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="majordiv clearfix">
          <div class="majorText left">教材类型:</div>
          <div class="left searchul border">
            <ul class="majorul clearfix left">
              <li
                v-for="(item, index) in bookType"
                class="left"
                :key="index"
                @click="selectBook(index)"
                :class="{ activeMajor: index == currentBook }"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
        <div class="majordiv clearfix">
          <div class="majorText secondstyle">出版时间：</div>
          <div class="border searchul clearfix">
            <ul class="majorul clearfix  left">
              <li
                v-for="(item, index) in publishYearData"
                class="left"
                :key="index"
                @click="selectPublishTimeBook(item.id)"
                :class="{ activeMajor: index == currentPublishTime }"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
        <div class="majordiv clearfix">
          <div class="majorText secondstyle">优秀教材：</div>
          <div class="border searchul clearfix">
            <ul class="majorul clearfix  left">
              <li
                v-for="(item, index) in youBookData"
                class="left"
                :key="index"
                @click="selectYouBook(index)"
                :class="{ activeMajor: index == currentYouBook }"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>

        <div class="majordiv clearfix">
          <div class="majorText secondstyle">教材层次：</div>
          <div class="border searchul clearfix">
            <ul class="majorul clearfix  left">
              <li
                v-for="(item, index) in bookLevelData"
                class="left"
                :key="index"
                @click="selectBookLevel(item.id)"
                :class="{ activeMajor: item.id == currentBookLevel }"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>

        <div v-if="currentBookLevel != ''" class="majordiv clearfix" :class="{ autoHeight: onOffBookDa }">
          <div
            class="majorText  secondstyle"
            :class="{ autoHeightMajor: onOffBookDa }"
          >
            专业大类：
          </div>
          <div class="border searchul clearfix" :class="{ autoHeightUL: onOffBookDa }">
            <ul
              class="majorul clearfix left"
              :class="{ autoHeightULseco: onOffBookDa }"
            >
              <li
                v-for="(item, index) in majorDaData"
                class="left"
                :key="index"
                @click="selectMajorDa(item.id)"
                :class="{ activeMajor: item.id == currentMajorDa }"
              >
                {{ item.name }}
              </li>
            </ul>
            <div class="right onOfftext" @click="openOrShutBookDa">
              {{ onOffBookDa ? '收起' : '展开' }}
              <img
                v-if="!onOffBookDa"
                class="arrowimg"
                src="../../assets/img/down.png"
                alt=""
              />
              <img
                v-else
                class="arrowimg"
                src="../../assets/img/up.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <div
          v-show="showMajorType"
          class="majordiv clearfix"
          :class="{ autoHeight: onOffBookLei }"
        >
          <div
            class="majorText secondstyle"
            :class="{ autoHeightMajor: onOffBookLei }"
          >
            专业类：
          </div>
          <div class="border searchul clearfix" :class="{ autoHeightUL: onOffBookLei }">
            <ul
              class="majorul clearfix  left"
              :class="{ autoHeightULseco: onOffBookLei }"
            >
              <li
                v-for="(item, index) in majorLeiData"
                class="left"
                :key="index"
                @click="selectMajorLei(item.id)"
                :class="{ activeMajor: item.id == currentMajorLei }"
              >
                {{ item.name }}
              </li>
            </ul>
            <div class="onOfftext right" @click="openOrShutBookLei">
              {{ onOffBookLei ? '收起' : '展开' }}
              <img
                v-if="!onOffBookLei"
                class="arrowimg"
                src="../../assets/img/down.png"
                alt=""
              />
              <img
                v-else
                class="arrowimg"
                src="../../assets/img/up.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <div
          v-show="showMajor"
          class="majordiv clearfix"
          :class="{ autoHeight: onOffBookMajor }"
        >
          <div
            class="majorText secondstyle"
            :class="{ autoHeightMajor: onOffBookMajor }"
          >
            专业：
          </div>
          <div
            class="border searchul clearfix"
            :class="{ autoHeightUL: onOffBookMajor }"
          >
            <ul
              class="majorul clearfix  left"
              :class="{ autoHeightULseco: onOffBookMajor }"
            >
              <li
                v-for="(item, index) in majorData"
                class="left"
                :key="index"
                @click="selectMajor(item.id)"
                :class="{ activeMajor: item.id == currentMajor }"
              >
                {{ item.name }}
              </li>
            </ul>
            <div class="onOfftext right" @click="openOrShutBookMajor">
              {{ onOffBookMajor ? '收起' : '展开' }}
              <img
                v-if="!onOffBookMajor"
                class="arrowimg"
                src="../../assets/img/down.png"
                alt=""
              />
              <img
                v-else
                class="arrowimg"
                src="../../assets/img/up.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <div
          v-show="showCourse"
          class="majordiv clearfix"
          :class="{ autoHeight: onOffBookCourse }"
        >
          <div
            class="majorText secondstyle"
            :class="{ autoHeightMajor: onOffBookCourse }"
          >
            课程：
          </div>
          <div
            class="border clearfix"
            :class="{ autoHeightUL: onOffBookCourse }"
          >
            <ul
              class="majorul clearfix  left"
              :class="{ autoHeightULseco: onOffBookCourse }"
            >
              <li
                v-for="(item, index) in courseData"
                class="left"
                :key="index"
                @click="selectCourse(item.id)"
                :class="{ activeMajor: item.id == currentCourse }"
              >
                {{ item.name }}
              </li>
            </ul>
            <div class="onOfftext right" @click="openOrShutBookCourse">
              {{ onOffBookCourse ? '收起' : '展开' }}
              <img
                v-if="!onOffBookCourse"
                class="arrowimg"
                src="../../assets/img/down.png"
                alt=""
              />
              <img
                v-else
                class="arrowimg"
                src="../../assets/img/up.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="searchitem clearfix searchinput">
          <div class="left">

            <el-input
              class="input"
              style="width: 500px"
              v-model="searchContont"
              placeholder="请输入教材名称"
            ></el-input>
          </div>
          <div class="left searchbutton" @click="search">搜 索</div>
        </div>
      </div>
      <div>
        <ul class="clearfix bookMajorul">
          <p class="noText" v-if="bookData.length == 0">暂无数据</p>
          <li
            class="left"
            @click="getdetails(item.id)"
            :key="index"
            v-for="(item, index) in bookData"
          >
            <div class="majorLeft left">
              <img
                v-if="item.coverUrl == ''"
                class="majorImg"
                src="../../assets/img/noimage.jpeg"
                alt=""
              />
              <img
                v-else
                class="majorImg"
                v-lazy="item.coverUrl"
                alt=""
              />
            </div>
            <div class="majorRight left">
              <p class="bookTitle2">{{ item.teachName }}</p>
              <p class="commoncss">
                作者:<span class="ml">{{ item.author }}</span>
              </p>
              <p class="commoncss">
                书号:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.isbn }}
              </p>
              <p class="commoncss">出版社:{{ item.name }}</p>
              <p class="commoncss">定价:
                <span data-v-575259fd="" class="pricetext">￥{{ item.pricing }}</span>
                </p>
              <!-- <div class="divcard" @click.stop="joinCart(item)">
                <img class="cartimg" src="../../assets/img/car2.png" alt="" />
                <span>加入选书</span>
              </div> -->
            </div>
          </li>
        </ul>
      </div>

      <div class="block">
        <el-pagination
          layout="total,prev, pager, next,jumper"
          :total="total"
          :current-page="bookParam.pageNum"
          :page-size="bookParam.pageSize"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <modelNew @close="close" v-if="showModel" :pressId="bookId"></modelNew>
  </div>
</template>
<script>
import { Loading } from 'element-ui'
import { getSheetId } from '../../api/wapi'
import { mapMutations, mapState, mapGetters } from 'vuex'
import { api } from '../../assets/api/axios'
import modelNew from '../common/modelNew.vue'
import {
  selectMaterialCategory,
  selectTeachingMaterial,
  selectProvincePress,
  bigMajor,
} from '../../api/home/index.js'
import { hasSemester } from '../../api/index.js'
export default {
  data() {
    return {
      sheetId: '',
      isLoading:false,
      currentBookData: {},
      majorSort: [],
      beginDate: '',
      endDate: '',
      searchContont: '',
      showModel: false,
      matItem: [],
      active: '',
      pageBean: {
        pageNum: 1,
        pageSize: 12,
        typeId: '',
        teamatName: '',
      },
      total: 0,
      currentMajor: 0,
      currentPress: '',
      currentBook: 0,
      currentMajorDa: 0,
      currentMajorLei: 0,
      currentCourse: 0,
      currentYouBook: 0,
      currentBookLevel: 3,
      currentPublishTime:0,
      onOff: false,
      onOffBook: false,
      onOffBookCourse: false,
      onOffBookMajor: false,
      onOffBookLei: false,
      onOffBookDa: false,
      showMajorType: false,
      showCourse: false,
      showMajor: false,
      pressData: [],
      bookParam: {
        name: '',
        pageNum: 1,
        pageSize: 9,
        specialtyGeneraId: '',
        textbookType: '',
        textbookGradeType: '',
        useLevelType:'',
        typeId: '',
        platformId:'',
        publishTimeType:0,
        specialtyClassId: '',
        chubanseId: '',
        classId: '',
      },
      courseData: [
        { id: '', name: '全部' },
        { id: 4, name: '种子质量检测技术' },
        { id: 3, name: '大田作物种子生产技术' },
        { id: 1, name: '种子市场营销' },
        { id: 2, name: '种子加工贮藏技术' },
      ],
      majorData: [
        { id: '', name: '全部' },
        { id: 4, name: '种子生产与经营' },
      ],
      majorLeiData: [],
      majorDaData: [],
      bookData: [],
      bookType: [
        { id: '', name: '全部' },
        { id: 1, name: '马工程教材' },
        { id: 2, name: '思政课教材' },
        { id: 3, name: '国规教材' },
        { id: 4, name: '统编教材' },
        { id: 5, name: '省规教材' },
        { id: 6, name: '其他教材' },
      ],
      youBookData: [
        { id: '', name: '全部' },
        { id: 2, name: '国家优秀教材' },
        { id: 3, name: '省优秀教材' },
      ],
      bookLevelData: [],
      benkeLevelData:[
        { id: '', name: '全部' },
        { id: 1, name: '本科教材' },
        { id: 2, name: '通用教材' },
        { id: 3, name: '高职教材' },
        { id: 4, name: '中职教材' },
        { id: 8, name: '职业通用教材' },
      ],
      publishYearData:[
        { id: 0, name: '全部' },
        { id: 1, name: '近一年' },
        { id: 2, name: '近两年' },
        { id: 3, name: '近三年' },
      ],
      gaozhiLevelData:[
        { id: '', name: '全部' },
        { id: 3, name: '高职教材' },
        { id: 4, name: '中职教材' },
        { id: 8, name: '职业通用教材' },
      ],
      bookId: '',
    }
  },
  created() {
    this.getPress()
    this.bookParam.platformId = this.resSchoolId ? this.resSchoolId :'';
    if (this.resSchoolLevel !=1 ) {
      this.bookLevelData = this.benkeLevelData;
      this.currentBookLevel = '';
    }else{
      this.bookLevelData = this.gaozhiLevelData;
      this.currentBookLevel = '';
    }
    this.bookParam.useLevelType = this.currentBookLevel;
    if (this.$route.query.chubanseId) {
      this.bookParam.chubanseId = this.$route.query.chubanseId;
      this.currentPress = this.bookParam.chubanseId;
      this.onOff = true;
    }
    if (this.$route.query.useLevelType) {
      this.bookParam.useLevelType = this.$route.query.useLevelType;
      this.currentBookLevel = this.bookParam.useLevelType;
    }
    this.getBookList(this.bookParam)
    this.getBigData()
  },
  provide() {
    return {
      updateList: this.updateList,
    }
  },
  computed: {
    ...mapGetters(['resStatus', 'resBookSelectionAuthority','resSchoolId','resSchoolLevel']),
  },
  components: {
    modelNew,
  },
  
  methods: {
    updateList() {},
    getMajorType(data){
        var type;
        switch (data) {
          case 1 :
          case 2 :
            type = 1;
            break;
          case 3:
          case 4:
          case 8:
            type = 2;
            break;
          default:
            type = 1;
            break;
        }
        return type
    },
    getBigData() {

      bigMajor({code:this.getMajorType(this.currentBookLevel)}).then((res) => {
        if (res.status == 0) {
          this.majorDaData = res.data
          this.majorDaData.unshift({
            name: '全部',
            id: '',
          })
        }
      })
    },
    // 判断是否有可用的选书清单
    visableSheetInfo(matData) {
      let loadingInstance = Loading.service({ background: 'rgba(0,0,0,0.5)' })
      getSheetId()
        .then((result) => {
          this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close()
          })
          if (result.data) {
            var data = result.data[0]
            this.sheetId = data.fid
            matData.sheetId = this.sheetId
            matData.materialId = matData.fid
            this.showModel = true
            this.currentBookData = matData
          } else {
            this.$confirm('暂无可供选书的清单，无法进行选书', '提示', {
              showClose: true,
              showCancelButton: false,
              showConfirmButton: false,
            })
          }
        })
        .catch((err) => {
          this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close()
          })
        })
    },
    joinCart(data) {
      let token = localStorage.getItem('Token')
      if (!token) {
        this.$confirm('请先登录再进行操作', '提示', {
          showClose: true,
          showCancelButton: false,
          showConfirmButton: false,
        })
        return
      }
      if (this.resBookSelectionAuthority != 1) {
        this.$message.error('您没有选书权限')
        return
      }
      hasSemester().then((res) => {
        if (res.status == 0) {
          this.bookId = data.id
          this.showModel = true
        } else {
          this.$message.error('还没有开启的学期')
          return
        }
      })
    },
    selectPress(index,id) {
      if (this.currentPress == id) {
        return;
      }
      this.currentPress = id
      this.bookParam.chubanseId = this.pressData[index].id;
      this.bookParam.pageNum = 1;
      this.getBookList(this.bookParam)
    },
    selectPublishTimeBook(id){
      if (this.currentPublishTime == id) {
        return;
      }
      this.currentPublishTime = id;
      this.bookParam.publishTimeType = id;
      this.bookParam.pageNum = 1;
      this.getBookList(this.bookParam)
    },
    getPress() {
      var platformId = this.resSchoolId ? this.resSchoolId :'';
      selectProvincePress({platformId:platformId})
        .then((res) => {
          this.pressData = res.data
          this.pressData.unshift({
            name: '全部',
            id: '',
          })
        })
        .catch(() => {})
    },
    selectMajor(id) {
      if (id == this.currentMajor) {
        return;
      }
      this.currentMajor = id
      this.bookParam.typeId = id;
      if (id == '') {
        this.showCourse = false
      } else {
        this.getMajorListBig(4,id)
        this.showCourse = true
      }
      this.currentCourse = ''
      this.bookParam.classId = ''
      this.bookParam.pageNum = 1;
      this.getBookList(this.bookParam)
    },
    selectYouBook(index) {
      if (index == this.currentYouBook) {
        return;
      }
      this.currentYouBook = index
      this.bookParam.textbookGradeType = this.youBookData[index].id
      this.bookParam.pageNum = 1;
      this.getBookList(this.bookParam)
    },
    selectCourse(id) {
      if (this.currentCourse == id) {
        return;
      }
      this.currentCourse = id
      this.bookParam.classId = id
      this.bookParam.pageNum = 1;
      this.getBookList(this.bookParam)
    },
    selectMajorLei(id) {
      if (id !=this.currentMajorLei) {
        this.currentMajorLei = id
        this.bookParam.specialtyClassId = id
        if (id == '') {
          this.showCourse = false
          this.showMajor = false
        } else  {
          this.getMajorListBig(3,id)
          this.showMajor = true
        }
        this.currentMajor = '';
        this.currentCourse = '';
        this.bookParam.typeId = ''
        this.bookParam.classId = ''
        this.bookParam.pageNum = 1;
        this.getBookList(this.bookParam)
      }
    },
    selectMajorDa(id) {
      console.log("id====>",id)
      if (this.currentMajorDa == id) {
        return;
      }
      this.currentMajorDa = id;
      this.bookParam.specialtyGeneraId = id;
      if (id == '') {
        this.showMajorType = false
        this.showCourse = false
        this.showMajor = false
      } else {
        this.getMajorListBig(2, id)
        this.showMajorType = true
      }
      this.currentMajorLei = '';
      this.currentMajor = '';
      this.currentCourse = '';
      this.bookParam.specialtyClassId = ''
      this.bookParam.typeId = ''
      this.bookParam.classId = ''
      this.bookParam.pageNum = 1;
      this.getBookList(this.bookParam)
    },
    // 教材层册筛选
    selectBookLevel(id) {
      if ( this.currentBookLevel == id) {
        return
      }
      this.bookParam.pageNum = 1;
      this.currentBookLevel = id
      this.bookParam.useLevelType = id;
      this.bookParam.specialtyGeneraId = '';
      this.bookParam.specialtyClassId = ''
      this.bookParam.typeId = ''
      this.bookParam.classId = ''
      this.currentMajor = '';
      this.currentMajorDa = '';
      this.currentMajorLei = '';
      this.currentCourse = '';
      this.showMajorType = false
      this.showCourse = false
      this.showMajor = false
      this.getBigData();
      this.getBookList(this.bookParam)
    },
    getdetails(fid) {
      this.$router.push({
        path: '/onLine/Matdetails',
        query: {
          fid: fid,
        },
      })
    },
    getBookList(params) {
      this.isLoading = true;
      selectTeachingMaterial(params)
        .then((res) => {
          this.isLoading = false;
          res.data.forEach(item => {
            item.pricing = item.pricing.toFixed(2);
          });
          this.bookData = res.data
          this.total = res.page.total
        })
        .catch(() => {
          this.isLoading = false;
        })
    },
    search() {
      this.bookParam.name = this.searchContont
      this.getBookList(this.bookParam)
    },
    getMajorList() {
      selectMaterialCategory({ parentId: 0 })
        .then((res) => {
          if (res.status == 0) {
            this.majorData = res.data
            this.majorData.unshift({
              name: '全部',
              id: '',
            })
          }
        })
        .catch(() => {})
    },
    async getMajorListBig(type, parentId) {
      let res = await selectMaterialCategory({ parentId: parentId })
      if (res.status == 0) {
        if (type == 1) {
        } else if (type == 2) {
          this.majorLeiData = res.data
          this.majorLeiData.unshift({
            name: '全部',
            id: '',
          })
        } else if (type == 3) {
          this.majorData = res.data
          this.majorData.unshift({
            name: '全部',
            id: '',
          })
        } else {
          this.courseData = res.data
          this.courseData.unshift({
            name: '全部',
            id: '',
          })
        }
      }
    },
    close() {
      this.showModel = false
    },
    showmodelclick() {
      this.showModel = true
      this.currentData = {}
    },
    openOrShut() {
      this.onOff = !this.onOff
    },
    openOrShutBook() {
      this.onOffBook = !this.onOffBook
    },
    openOrShutBookCourse() {
      this.onOffBookCourse = !this.onOffBookCourse
    },
    openOrShutBookDa() {
      this.onOffBookDa = !this.onOffBookDa
    },
    openOrShutBookLei() {
      this.onOffBookLei = !this.onOffBookLei
    },
    openOrShutBookMajor() {
      this.onOffBookMajor = !this.onOffBookMajor
    },
    selectBook(index) {
      if (this.currentBook == index) {
        return;
      }
      this.bookParam.textbookType = this.bookType[index].id
      this.currentBook = index
      this.bookParam.pageNum = 1;
      this.getBookList(this.bookParam)
    },
    handleSizeChange(newSize) {},
    handleCurrentChange(newPage) {
      this.bookParam.pageNum = newPage
      this.getBookList(this.bookParam)
    },
  },
}
</script>

<style lang="scss" scoped>
.main{
  background-color: white;
  padding-top: 29px;
}
.bg{
  background-color: white;
}
.noText {
  text-align: center;
  margin-top: 50px;
}
.cartimg {
  width: 20px;
  height: 19px;
  display: inline-block;
  vertical-align: middle;
  margin-top: -2px;
  margin-right: 5px;
}
.divcard {
  width: 102px;
  height: 31px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  margin-top: 10px;
  line-height: 31px;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  span {
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 31px;
  }
}
.pricecolor {
  color: #B80D03;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 24px;
}

.majorImg {
  width: 130px;
  height: 181px;
  // background-color: #f2f2f2;
  object-fit: contain;
}
.majorRight {
  width: calc(100% - 150px);
  margin-left: 20px;
}
.pricetext{
  color: #b80d03;
  font-size: 18px;
  font-weight: 500;
}
.commoncss {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 30px;
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-align: justify;
  text-overflow: ellipsis;
}
.bookTitle2 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #111111;
  width: 100%;
  height: 40px;
  line-height: 20px;
  margin: 9px 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-align: justify;
  text-overflow: ellipsis;

}
.bookMajorul{
  height: 650px;
  min-height: 650px;
}

.bookMajorul li {
  width: calc(33.333% - 65px);
  height: 178px;
  padding: 20px;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0);
}
.bookMajorul li:hover{
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.05);
  z-index: 999;
}
.bookMajorul li:nth-child(3n+2){
  margin: 0px 30px;
}
.input {
  margin-right: 10px;
}
.jian {
  margin-left: 10px;
  margin-right: 10px;
  font-size: 14px;
}
.pressdate {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  margin-right: 10px;
}
.searchbutton {
  width: 77px;
  height: 36px;
  background: #0082F0;
  font-size: 14px !important;
  font-family: Microsoft YaHei;
  color: #ffffff;
  line-height: 36px;
  font-weight: 400;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
}
.blockpicker {
  display: inline-block;
}
.searchitem {
  margin-top: 20px;
  margin-bottom: 20px;
}
.border {
  border-top: 1px dashed #e9e9e9;
  float: left;
}
.secondstyle {
  float: left;
}
.selectdivAll {
  border: 1px solid #e9e9e9;
}
.majorText {
  width: 98px;
  height: 40px;
  background: #E9E9E9;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  color: #333333;
}
.arrowimg {
  width: 9px;
  height: 5px;
  margin-top: -4px;
  display: inline-block;
  vertical-align: middle;
}
.onOfftext {
  margin-top: 14px;
  font-size: 12px;
  padding-right: 20px;
  display: inline-block;
  vertical-align: middle;
}
.activeMajor {
  background: #0082F0;
  border-radius: 4px;
  color: #fff !important;
}
.searchul{
  width: 1099px;
}
.majorul {
  height: 38px;
  width: 1000px;
  overflow: hidden;
  min-height: 38px;
  // border: 1px #E9E9E9 solid;
}
.majorul li {
  margin: 0 14px;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  padding: 6px 10px;
  margin-top: 8px;
  margin-bottom: 8px;
  cursor: pointer;
}
.autoHeightMajor {
  height: 100% !important;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
}
.autoHeight {
  height: auto !important;
}
.autoHeightULseco {
  height: auto !important;
  margin-left: 0px;
}
.autoHeightUL {
  height: auto !important;
  margin-left: 100px;
}
.clearfix:after {
  content: '.';
  display: block;
  clear: both;
  visibility: hidden;
}
.majordiv {
  width: 1198px;
  height: 40px;
  background: #ffffff;
  position: relative;
}
.majorList {
  width: 930px;
}
.majorAllButton {
  margin-right: 40px;
}
.majorall {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  border-bottom: 1px solid #fff8f8f8;
  margin-top: 20px;
}
.banner {
  width: 100%;
  height: 180px;
  img {
    width: 100%;
    height: 180px;
  }
}
.sort {
  overflow: hidden;
  margin-top: 35px;
  margin-bottom: 25px;
  background: #fff;
  height: 165px;
  padding: 0 31px;
  .major {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    width: 80px;
  }

  .majorItem {
    float: left;
    width: 130px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 20px;
  }
}
.itemMar {
  margin: 30px 0;
}
.active {
  float: left;
  width: 80px;
  height: 23px;
  background: #0082F0;
  border-radius: 2px;
  font-size: 14px;
  color: rgba(255, 255, 255, 1) !important;
  line-height: 23px;
  text-align: center;
  margin-right: 30px;
}
.item {
  width: 100%;
  height: 100%;
  // overflow: hidden;
  // height: 482px;
  .itemImg {
    width: 100%;
    height: 180px;
  }
}
.searchBut {
  width: 77px;
  height: 34px;
  background: #0082F0;
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  line-height: 34px;
  text-align: center;
  margin-top: 20px;
  cursor: pointer;
}
</style>
<style lang="scss">
.searchinput .el-input__inner {
  height: 36px !important;
  line-height: 36px !important;
  border-radius: 0px !important;
}
.block {
  margin-top: 50px;
  padding-bottom: 50px;
  text-align: center;
}
.el-pager {
  font-size: 12px !important;
  color: rgba(102, 102, 102, 1);
  li {
    width: 32px;
    height: 27px;
    border: 1px solid rgba(153, 153, 153, 1);
    margin-right: 15px !important;
    font-weight: 400;
  }
}
.el-pager li.active {
  color: #fff !important;
  background: #0082F0;
  cursor: pointer;
}
.el-pager li.active + li {
  border-left: 1px solid #999;
}
</style>
